import {
  COLLECTION_LIST_GET_SUCCESS,
  CREATE_COLLECTION_SUCCESS,
  GET_COLLECTION_SUCCESS,
  SET_PAGE_VIEW,
  DELETE_COLLECTION_SUCCESS,
  GET_COLLECTION_COURSE_LIST_SUCCESS,
  COURSE_DELETE_SUCCESS,
  EDIT_COURSE_COLLECTION_INDEX_SUCCESS,
  COURSE_CLONE_SUCCESS,
  GET_COLLECTION_SETTINGS_SUCCESS,
  PATCH_COURSE_COLLECTION_SUCCESS,
  PATCH_COLLECTION_SETTINGS_SUCCESS,
  GET_COLLECTION_LANDING_PAGE_SUCCESS,
  PATCH_COLLECTION_LANDING_PAGE_SUCCESS,
} from './type'
// eslint-disable-next-line
export default function (
  state = {
    list: [],
    teams: [],
    collection: null,
    collectionSettings: {},
    constants: null,
    pageView: 'Mini Courses',
    courses: null,
    landingPageSettings: null,
    landingPage: `<div class="simple-box-wrapper"> 
                <div class="simple-box">
                    <div class="column">
                      <h2>Heading </h2>
                      <p>I'm a paragraph. Click to start writing that will inform, inspire, or encourage your community. We know you have so many things to share with the world. Happy editing!</p>
                      <div class="img-wrapper">
                        <img src="https://cdn.minicoursegenerator.com/assets/editor/sample-img.jpg"></img>
                      </div>
                    </div>
                  </div>
                </div>`,

    memberList: {},
  },
  action,
) {
  const { payload, type } = action

  switch (type) {
    case COLLECTION_LIST_GET_SUCCESS:
      return { ...state, list: payload.results }

    case CREATE_COLLECTION_SUCCESS:
      return {
        ...state,
        list: [payload.response, ...state.list],
      }
    case DELETE_COLLECTION_SUCCESS:
      let collectionId = payload
      state = {
        ...state,
        list: state.list.filter(collection => {
          return collection.id !== collectionId
        }),
      }

      return state
    case EDIT_COURSE_COLLECTION_INDEX_SUCCESS:
      return state
    case GET_COLLECTION_SUCCESS:
      return {
        ...state,
        collection: payload,
      }
    case SET_PAGE_VIEW:
      return { ...state, pageView: payload }

    case GET_COLLECTION_COURSE_LIST_SUCCESS:
      return { ...state, courses: payload }

    case COURSE_DELETE_SUCCESS:
      return state

    case COURSE_CLONE_SUCCESS:
      return state
    case PATCH_COURSE_COLLECTION_SUCCESS:
      const patchedCollection = { ...state.collection }
      payload.content._contents.forEach(value => {
        if (value._path === 'collectionName') {
          patchedCollection.name = value.value
        } else {
          patchedCollection[value._path] = value.value
        }
      })
      return {
        ...state,
        collection: patchedCollection,
      }
    case GET_COLLECTION_SETTINGS_SUCCESS:
      state = {
        ...state,
        collectionSettings: payload.response,
      }
      return state
    case PATCH_COLLECTION_SETTINGS_SUCCESS:
      var newCollectionSettings = state.collectionSettings
      payload.content._contents.map(value => {
        newCollectionSettings[value._path] = value._value
      })
      state = {
        ...state,
        collectionSettings: newCollectionSettings,
      }
      return state

    case GET_COLLECTION_LANDING_PAGE_SUCCESS:
      state = {
        ...state,
        landingPageSettings: payload.response,
      }
      return state

    case PATCH_COLLECTION_LANDING_PAGE_SUCCESS:
      const updatedSettings = { ...state.landingPageSettings }

      payload.response.forEach(item => {
        updatedSettings[item.path] = item.value
      })
      return {
        ...state,
        landingPageSettings: updatedSettings,
      }
    default:
      return state
  }
}
